// import React, { useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Rating,
//   Typography,
//   Box,
//   Alert,
//   CircularProgress
// } from '@mui/material';
// import { getDatabase, ref, push, update } from 'firebase/database';

// const ReviewModal = ({ open, onClose, appointment, patientId, patientName, doctorId }) => {
//   const [rating, setRating] = useState(0);
//   const [comment, setComment] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState(false);

//   const handleSubmit = async () => {
//     if (rating === 0) {
//       setError('Please select a rating');
//       return;
//     }

//     setLoading(true);
//     setError('');

//     try {
//       const db = getDatabase();
//       const reviewId = push(ref(db, `reviews/${doctorId}`)).key;
      
//       const reviewData = {
//         patientId,
//         patientName,
//         appointmentId: appointment.id,
//         rating,
//         comment: comment.trim() || 'No comment provided',
//         date: new Date().toISOString(),
//         doctorId
//       };

//       // Save review
//       await update(ref(db, `reviews/${doctorId}/${reviewId}`), reviewData);
      
//       // Mark appointment as reviewed
//       await update(ref(db, `users/${patientId}/appointments/${appointment.id}`), {
//         reviewed: true,
//         reviewId
//       });

//       setSuccess(true);
//       setTimeout(() => {
//         onClose();
//         setRating(0);
//         setComment('');
//         setSuccess(false);
//       }, 1500);
//     } catch (err) {
//       setError('Failed to submit review. Please try again.');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     if (!loading) {
//       onClose();
//       setRating(0);
//       setComment('');
//       setError('');
//     }
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ borderBottom: '1px solid #e5e7eb', pb: 2 }}>
//         <Box display="flex" alignItems="center" gap={1}>
//           <span style={{ fontSize: 28 }}>⭐</span>
//           <Typography variant="h6" component="span" fontWeight="bold">
//             Rate Your Experience
//           </Typography>
//         </Box>
//         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//           Dr. {appointment?.doctorName || 'Doctor'}
//         </Typography>
//       </DialogTitle>

//       <DialogContent sx={{ pt: 3 }}>
//         {success ? (
//           <Alert severity="success" sx={{ mb: 2 }}>
//             Thank you for your feedback!
//           </Alert>
//         ) : (
//           <>
//             {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            
//             <Box sx={{ textAlign: 'center', mb: 3 }}>
//               <Typography component="legend" fontWeight="bold" mb={1}>
//                 How was your experience?
//               </Typography>
//               <Rating
//                 value={rating}
//                 onChange={(e, newValue) => setRating(newValue)}
//                 size="large"
//                 sx={{ fontSize: 48 }}
//                 disabled={loading}
//               />
//               <Typography variant="caption" color="text.secondary" display="block" mt={1}>
//                 {rating === 1 && 'Poor'}
//                 {rating === 2 && 'Fair'}
//                 {rating === 3 && 'Good'}
//                 {rating === 4 && 'Very Good'}
//                 {rating === 5 && 'Excellent!'}
//               </Typography>
//             </Box>

//             <TextField
//               label="Write your review (optional)"
//               multiline
//               rows={3}
//               fullWidth
//               value={comment}
//               onChange={(e) => setComment(e.target.value)}
//               placeholder="Share details about your experience with the doctor..."
//               disabled={loading}
//               sx={{ mb: 2 }}
//             />

//             <Typography variant="caption" color="text.secondary">
//               Your feedback helps other patients make informed decisions.
//             </Typography>
//           </>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2, borderTop: '1px solid #e5e7eb' }}>
//         <Button onClick={handleClose} disabled={loading}>
//           Cancel
//         </Button>
//         {!success && (
//           <Button
//             onClick={handleSubmit}
//             variant="contained"
//             disabled={loading || rating === 0}
//             sx={{
//               background: 'linear-gradient(135deg, #d97706, #f59e0b)',
//               '&:hover': { background: 'linear-gradient(135deg, #b45309, #d97706)' }
//             }}
//           >
//             {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Review'}
//           </Button>
//         )}
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default ReviewModal;

import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Rating,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { getDatabase, ref, push, update } from 'firebase/database';

const ReviewModal = ({ open, onClose, appointment, patientId, patientName, doctorId }) => {
  const [rating, setRating]   = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState(false);

  // ── FIX 1: resolve doctorId from multiple possible fields ──
  const resolvedDoctorId =
    doctorId ||
    appointment?.doctorId ||
    appointment?.DoctorId ||
    appointment?.doctor_id ||
    null;

  // ── FIX 2: strip leading "Dr." / "dr." so we never double it ──
  const rawDoctorName =
    appointment?.doctorName ||
    appointment?.DoctorName ||
    appointment?.doctor ||
    '';
  const doctorDisplayName = rawDoctorName.replace(/^Dr\.?\s*/i, '').trim() || 'Doctor';

  const handleSubmit = async () => {
    if (rating === 0) {
      setError('Please select a rating');
      return;
    }

    if (!resolvedDoctorId) {
      setError('Unable to identify the doctor. Please try again.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const db = getDatabase();
      const reviewRef = push(ref(db, `reviews/${resolvedDoctorId}`));
      const reviewId  = reviewRef.key;

      const reviewData = {
        patientId,
        patientName,
        appointmentId: appointment.id,
        rating,
        comment:  comment.trim() || 'No comment provided',
        date:     new Date().toISOString(),
        doctorId: resolvedDoctorId,
      };

      // Save review under doctor
      await update(ref(db, `reviews/${resolvedDoctorId}/${reviewId}`), reviewData);

      // Mark appointment as reviewed
      await update(ref(db, `users/${patientId}/appointments/${appointment.id}`), {
        reviewed: true,
        reviewId,
      });

      setSuccess(true);
      setTimeout(() => {
        onClose();
        setRating(0);
        setComment('');
        setSuccess(false);
      }, 1500);
    } catch (err) {
      setError('Failed to submit review. Please try again.');
      console.error('ReviewModal error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
      setRating(0);
      setComment('');
      setError('');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ borderBottom: '1px solid #e5e7eb', pb: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <span style={{ fontSize: 28 }}>⭐</span>
          <Typography variant="h6" component="span" fontWeight="bold">
            Rate Your Experience
          </Typography>
        </Box>
        {/* FIX 2: always prefix exactly one "Dr." */}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Dr. {doctorDisplayName}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        {success ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            Thank you for your feedback!
          </Alert>
        ) : (
          <>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Typography component="legend" fontWeight="bold" mb={1}>
                How was your experience?
              </Typography>
              <Rating
                value={rating}
                onChange={(e, newValue) => setRating(newValue)}
                size="large"
                sx={{ fontSize: 48 }}
                disabled={loading}
              />
              <Typography variant="caption" color="text.secondary" display="block" mt={1}>
                {rating === 1 && 'Poor'}
                {rating === 2 && 'Fair'}
                {rating === 3 && 'Good'}
                {rating === 4 && 'Very Good'}
                {rating === 5 && 'Excellent!'}
              </Typography>
            </Box>

            <TextField
              label="Write your review (optional)"
              multiline
              rows={3}
              fullWidth
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Share details about your experience with the doctor..."
              disabled={loading}
              sx={{ mb: 2 }}
            />

            <Typography variant="caption" color="text.secondary">
              Your feedback helps other patients make informed decisions.
            </Typography>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #e5e7eb' }}>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        {!success && (
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={loading || rating === 0}
            sx={{
              background: 'linear-gradient(135deg, #d97706, #f59e0b)',
              '&:hover': { background: 'linear-gradient(135deg, #b45309, #d97706)' },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Review'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ReviewModal;